import StarRating from 'star-rating.js';

export function ratingStars() {
  const $select = $('.rating-stars-select');
  if ($select && $select.length === 0) return;

  $select.each((i, el) => {
    const stars = new StarRating(el, {
      tooltip: false,
      stars: (el, item, index) => {
        el.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16">
          <path fill="#ebeff2" class="gl-star-full" d="M15.805 5.454l-4.407-.425a.764.764 0 0 1-.632-.476L9.188.652a.75.75 0 0 0-1.402 0L6.221 4.553c-.101.27-.354.45-.632.476l-4.407.425c-.656.065-.921.901-.43 1.352l3.322 2.975a.778.778 0 0 1 .24.759l-.998 4.172c-.151.656.543 1.197 1.124.85l3.675-2.202a.75.75 0 0 1 .77 0l3.675 2.202c.58.347 1.275-.18 1.123-.85l-.985-4.172a.778.778 0 0 1 .24-.76l3.321-2.974c.48-.45.202-1.287-.454-1.352z"/>
        </svg>`;
      },
    });
  });
}
